import { VCol } from 'vuetify/lib/components/VGrid';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VRadioGroup,
    _vm._g(
      _vm._b(
        {
          model: {
            value: _vm.selected,
            callback: function ($$v) {
              _vm.selected = $$v
            },
            expression: "selected",
          },
        },
        "VRadioGroup",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    ),
    _vm._l(_vm.radios, function (row, i) {
      return _c(
        VRow,
        { key: i },
        _vm._l(row, function (col) {
          return _c(
            VCol,
            { key: col[_vm.itemValue] },
            [
              _c(VRadio, {
                attrs: {
                  label: typeof col === "object" ? col[_vm.itemText] : col,
                  value: typeof col === "object" ? col[_vm.itemValue] : col,
                },
              }),
            ],
            1
          )
        }),
        1
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }